// extracted by mini-css-extract-plugin
export var divider = "_1n-0";
export var dividerText = "_1n-1";